import styles from "components/sections/search/AllSearchResult.module.scss";
import useTranslation from "next-translate/useTranslation";

export const SectionTitle = (props) => {
    const {t} = useTranslation('sections-search-SectionTitle');

    const {title, onClick} = props;
    return (
        <div className={styles.sectionTitleWrapper}>
            <span className={styles.sectionTitle}>{title}</span>
            <div className={styles.sectionTitleShowMore} onClick={onClick}>
                <span className={styles.sectionTitleShowMoreText}>{t('SectionTitle.showMore')}</span>
                {/*<ArrowRightIcon viewBox="0 0 16 16" className={styles.sectionTitleShowMoreIcon}/>*/}
            </div>
        </div>
    );
};
